<template>
  <div>
    <template v-if="pattern=='model'">
      必填
      <Checkbox label="必填" v-model="content.must"></Checkbox>
      <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
    </template>
      <div style="display: inline-block;width:100px;text-align: right;vertical-align:middle;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
    ：
    <Upload
				v-if="pattern=='submission'"
        :show-upload-list="false"
        :on-success="uploadSuccess"
        :disabled="pattern=='model'"
        style="display: inline-block;vertical-align:middle"
        :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
        :data="{MenuId:menuId,UserId:userId}"
        :action="getServerURL('default',true)">
      <Button
          icon="ios-cloud-upload-outline"
          :type="content.fileName?'success':'primary'"
      >
        {{content.fileName||'请选择文件'}}
      </Button>
    </Upload>
	<template v-else>
		<template v-if="!isEmpty(content.filesSrc)">
			<a :href="getServerURL('default',false)+'/'+content.filesSrc" v-if="content.filesSrc!=null" target="_blank">
        <Button type="success" style="margin-left: 10px;">下载文件</Button>
      </a>
		</template>
		<template v-else>暂未上传文件</template>
	</template>
    <template v-if="pattern=='model'&&companyName=='云联'">
      <i-switch size="large" style="margin-left:10px" true-value="1" false-value="0" v-model="content.seal">
        <span slot="open">盖章</span>
        <span slot="close">盖章</span>
      </i-switch>
      <!--<DatePicker type="date" :disabled="disabled" placeholder="文件" @on-change="content.selected = $event" style="width: 200px"></DatePicker>-->
      <Icon class="close-icon" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalFile",
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          fileName:'',
          filesSrc:'',
          seal:"0",
          must:false,
          allowSubmission:false,
        },
      }
    },
    methods:{
      uploadSuccess:function (response,file,fileList) {
        this.content.fileName = response.Data.name
        this.content.filesSrc = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||!this.isEmpty(this.content.filesSrc)){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    },
    computed:{
			companyName:function(){
				return companyName
			},
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>

<style scoped>

</style>